import { LightningElement, api} from 'lwc';

import { fetchAuthSession } from 'aws-amplify/auth';
import { get, patch, post } from 'aws-amplify/api';
import { IS_TESTING_NO_INTERNET, toTitleCase } from '../../../utils/basicUtils';


const HOST_TAB_OPTIONS = [
    {icon: 'material:dashboard', label: 'Dashboard', value: 'Dashboard', group: 'Hosting'},
    {icon: 'material:listings', label: 'Listings', value: 'Listings', group: 'Hosting'},
    {icon: 'material:calendar', label: 'Calendar', value: 'Calendar', group: 'Hosting'},
    {icon: 'material:reservations', label: 'Reservations', value: 'Reservations', group: 'Hosting'},
    {icon: 'material:messages', label: 'Messages', value: 'Messages', group: 'Hosting'},
    {icon: 'material:accountSettings', label: 'Account Info.', value: 'Account Info.', group: 'Settings'},
    {icon: 'material:payments', label: 'Payments', value: 'Payments', group: 'Settings'},
    {icon: 'material:identity', label: 'Identity', value: 'Identity', group: 'Settings'},
];

const STATUS_ICONS = {
    approved: 'approved-icon',
    banned: 'banned-icon',
    'under review': 'under-review-icon',
    'pending approval': 'pending-icon',
    draft: 'draft-icon'
}
function handleTemplateListings(listings) {
    if (!listings?.length) return [];

    return listings.map(lstng => {
        const messageCount = Number(lstng.message_count || 0);
        const unreadMessageCount = Number(lstng.unread_message_count || 0);
        const inquiryCount = Number(lstng.inquiry_count || 0);
        const unreadInquiryCount = Number(lstng.unread_inquiry_count || 0);

        return {
            ...lstng, 
            status: toTitleCase(lstng.status), 
            statusIcon: `slds-icon slds-icon_x-small ${STATUS_ICONS[lstng.status?.toLowerCase()]}`,
            property_name: lstng.property_name ?? 'Unknown',
            message_count: messageCount,
            unread_message_count: unreadMessageCount,
            inquiry_count: inquiryCount,
            unread_inquiry_count: unreadInquiryCount,
            hasReservationMessages: messageCount > 0,
            hasInquiries: inquiryCount > 0,
            pastReservationCountLabel: String(Number(lstng.past_reservation_count || 0)),
            unreadMessageCountLabel: String(unreadMessageCount),
            inquiryCountLabel: unreadInquiryCount > 0
                ? `${unreadInquiryCount} unread / ${inquiryCount} total`
                : String(inquiryCount),
        }
    })
}

const LISTING_ACTIONS = [
    {label: 'Edit', value: 'Edit'},
    {label: 'Availability', value: 'Availability'},
    {label: 'Delete', value: 'Delete'}
];


const LISTING_FIELDS = [
    'street',
    'city',
    'state',
    'property_name',
    'status',
];

const HOST_PAGE_TABS = [
    {label: 'Listings', value: 'Listings'},
    {label: 'Reservations', value: 'Reservations'}
];


export default class getWetHostHomePage extends LightningElement {
    _isTest = IS_TESTING_NO_INTERNET;
    _isLoading = false;
    listingActions = LISTING_ACTIONS;

    hostTabOptions = HOST_TAB_OPTIONS;
    activeHostTab = 'Listings';
    selectedReservationListingId;
    selectedReservationListingName;

    mobile = false;
    fakeListing = [
        {property_name: 'Pool 1', id: '1', status: 'draft', upcoming_reservations: 0, messages: null},
        {property_name: 'Pool 2', id: '2', status: null, upcoming_reservations: 2, messages: null},
        {property_name: 'Pool 3', id: '3', status: null, upcoming_reservations: 5, messages: 3},
        {property_name: 'Pool 4', id: '4', status: null, upcoming_reservations: 1, messages: 1},
    ];

    _idToken;
    async getIdToken() {
        if (!this._idToken) {
            const session = await fetchAuthSession();
            this._idToken = session.tokens?.idToken?.toString();
        }
        return this._idToken;
    }
    
    _templateListings = [];
    listings = [];
    async loadMe() {
        if (this._isTest) return;
        this._isLoading = true;
        try {
            
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }   
            const op = get({
                apiName: 'api',
                path: '/cognito/all-host-listings',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                },
            });

            const { body } = await op.response;
            const payload = await body.json();
            const listings = payload?.allListings || payload;
            console.log('here is listings in getWetHostHomePage.js: ', listings);
            this.listings = listings?.length 
                ? listings 
                : [];

            this._templateListings = handleTemplateListings(listings);
            
        } catch (error) {
            console.error('Error loading user profile', error);
        } finally {
            this._isLoading = false;
        }
    }

    
    async connectedCallback() {
        await this.loadMe();
    }

    
    _activeListing;
    activeListingId;
    modalConfig;
    inquiryThreads = [];
    inquiryReplyDrafts = {};
    blockedTimes = [];
    availabilityForm = {
        start_time: '',
        end_time: '',
        reason: ''
    };

    get hasInquiryThreads() {
        return this.inquiryThreads.length > 0;
    }

    get hasBlockedTimes() {
        return this.blockedTimes.length > 0;
    }

    get isAddBlockedTimeDisabled() {
        return !this.availabilityForm.start_time || !this.availabilityForm.end_time;
    }

    get hostPageTabs() {
        return HOST_PAGE_TABS.map(tab => {
            const isActive = this.activeHostTab === tab.value;

            return {
                ...tab,
                className: isActive
                    ? 'host-page-tab host-page-tab_active'
                    : 'host-page-tab',
                ariaSelected: isActive ? 'true' : 'false'
            };
        });
    }

    get isListingsTab() {
        return this.activeHostTab === 'Listings';
    }

    get isReservationsTab() {
        return this.activeHostTab === 'Reservations';
    }

    handleHostTabClick(event) {
        const value = event.currentTarget?.dataset?.value;
        if (!value) return;

        this.activeHostTab = value;

        if (value !== 'Reservations') {
            this.selectedReservationListingId = null;
            this.selectedReservationListingName = null;
        }
    }

    handleViewPastReservations(event) {
        const listingId = event.currentTarget?.dataset?.listingId;
        if (!listingId) return;

        const listing = this.listings.find(item => item.id === listingId);
        this.selectedReservationListingId = listingId;
        this.selectedReservationListingName = listing?.property_name || null;
        this.activeHostTab = 'Reservations';
    }

    handleListingAction(event) {
        const listingId = event.target?.dataset?.listingId;
        const {id, value} = event.detail;

        const listing = this.listings.find(l => l.id === listingId);

        console.log('here is listing id in handleListingAction() of getWetHostHomePage.js: ', listingId);

        if (listingId) {
            switch(value) {
                case 'Edit': 
                    this.dispatchEvent(new CustomEvent('edithostlisting', {
                        detail: {listingId},
                        bubbles: true,
                        composed: true
                    }));
                    return;
                case 'Availability':
                    this.openAvailabilityModal(listingId, listing);
                    return;
                case 'Delete':
                    this.activeListingId = listingId;
                    this._activeListing = listing;
                    const property_name = listing.property_name;
                    if (listing) {
                        this.modalConfig = {
                            isDelete: true,
                            modalTitle: 'Delete Listing',
                            deleteConfirmation: `Are you sure you want to delete "${property_name}"?`,
                            modalIntro: 'Type the name of your listing to proceed',
                            inputLabel: `Property Name: ${property_name}`,
                            cancelButtonLabel: 'Cancel',
                            okButtonLabel: 'Delete',
                            borderRadius: 'var(--slds-g-radius-border-4, 1.25rem)',
                        };
                    }   
                    return;
            }
        }
    }

    closeModal() {
        this.activeListingId = null;
        this.modalConfig = null;
        this._activeListing = null;
        this.inquiryThreads = [];
        this.inquiryReplyDrafts = {};
        this.blockedTimes = [];
        this.availabilityForm = {
            start_time: '',
            end_time: '',
            reason: ''
        };
    }

    async openAvailabilityModal(listingId, listing) {
        if (!listingId) return;

        this.activeListingId = listingId;
        this._activeListing = listing;
        this.modalConfig = {
            isAvailability: true,
            modalTitle: `Availability${listing?.property_name ? `: ${listing.property_name}` : ''}`,
            borderRadius: 'var(--slds-g-radius-border-4, 1.25rem)',
        };

        await this.loadListingAvailability(listingId);
    }

    async loadListingAvailability(listingId = this.activeListingId) {
        if (!listingId || this._isTest) return;

        this._isLoading = true;
        try {
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }

            const op = get({
                apiName: 'api',
                path: '/cognito/host/listings/unavailability',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                    queryParams: {
                        listingId
                    }
                },
            });

            const { body } = await op.response;
            const payload = await body.json();
            this.blockedTimes = this.formatBlockedTimes(payload?.blockedTimes || []);
        } catch (error) {
            this.showToast('Error loading availability', error?.message || error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    formatBlockedTimes(blockedTimes = []) {
        return blockedTimes.map(block => ({
            ...block,
            startLabel: block.start_time ? new Date(block.start_time).toLocaleString() : '',
            endLabel: block.end_time ? new Date(block.end_time).toLocaleString() : '',
            reasonLabel: block.reason || 'Unavailable'
        }));
    }

    handleAvailabilityInput(event) {
        const field = event.currentTarget?.dataset?.field;
        if (!field) return;

        this.availabilityForm = {
            ...this.availabilityForm,
            [field]: event.target.value
        };
    }

    async handleAddBlockedTime() {
        if (!this.activeListingId || this.isAddBlockedTimeDisabled) return;

        const startDate = new Date(this.availabilityForm.start_time);
        const endDate = new Date(this.availabilityForm.end_time);

        if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
            this.showToast('Invalid availability window', 'Enter a valid start and end time.', 'error');
            return;
        }

        if (startDate >= endDate) {
            this.showToast('Invalid availability window', 'End time must be after start time.', 'error');
            return;
        }

        this._isLoading = true;
        try {
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }

            const op = post({
                apiName: 'api',
                path: '/cognito/host/listings/unavailability',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        listingId: this.activeListingId,
                        blockedTimes: [{
                            start_time: startDate.toISOString(),
                            end_time: endDate.toISOString(),
                            reason: this.availabilityForm.reason || null
                        }]
                    }
                }
            });

            const { body } = await op.response;
            const payload = await body.json();
            this.blockedTimes = this.formatBlockedTimes([
                ...this.blockedTimes,
                ...(payload?.blockedTimes || [])
            ]);
            this.availabilityForm = {
                start_time: '',
                end_time: '',
                reason: ''
            };
            this.showToast('Availability updated', 'Blocked time was added.', 'success');
        } catch (error) {
            this.showToast('Error updating availability', error?.message || error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    async handleDeleteBlockedTime(event) {
        const unavailabilityId = event.currentTarget?.dataset?.id;
        if (!this.activeListingId || !unavailabilityId) return;

        this._isLoading = true;
        try {
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }

            const op = post({
                apiName: 'api',
                path: '/cognito/host/listings/unavailability-delete',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        listingId: this.activeListingId,
                        unavailabilityId
                    }
                }
            });

            await op.response;
            this.blockedTimes = this.blockedTimes.filter(block => block.id !== unavailabilityId);
            this.showToast('Availability updated', 'Blocked time was removed.', 'success');
        } catch (error) {
            this.showToast('Error updating availability', error?.message || error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    async handleOpenInquiries(event) {
        const listingId = event.currentTarget?.dataset?.listingId;
        if (!listingId) return;

        const listing = this.listings.find(l => l.id === listingId);
        this.activeListingId = listingId;
        this._activeListing = listing;
        this.modalConfig = {
            isInquiries: true,
            modalTitle: `Inquiries${listing?.property_name ? `: ${listing.property_name}` : ''}`,
            borderRadius: 'var(--slds-g-radius-border-4, 1.25rem)',
        };
        this._isLoading = true;

        try {
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }

            const op = get({
                apiName: 'api',
                path: '/cognito/host/listing-inquiries',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                    queryParams: {
                        listingId
                    }
                },
            });

            const { body } = await op.response;
            const payload = await body.json();
            this.inquiryThreads = this.formatInquiryThreads(payload?.inquiries || []);

            const refreshedListings = this.listings.map(item => (
                item.id === listingId
                    ? {...item, unread_inquiry_count: 0}
                    : item
            ));
            this.listings = refreshedListings;
            this._templateListings = handleTemplateListings(refreshedListings);
        } catch (error) {
            this.showToast('Error loading inquiries', error?.message || error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    formatInquiryThreads(threads = []) {
        return threads.map(thread => {
            const guestName = [thread.guest_first_name, thread.guest_last_name]
                .filter(Boolean)
                .join(' ')
                || thread.guest_email
                || 'Guest';
            const replyBody = this.inquiryReplyDrafts[thread.thread_id] || '';

            return {
                ...thread,
                guestName,
                replyBody,
                isReplyDisabled: !replyBody.trim(),
                lastMessageAtLabel: thread.last_message_at
                    ? new Date(thread.last_message_at).toLocaleString()
                    : '',
                messages: (thread.messages || []).map(message => ({
                    ...message,
                    messageClass: message.is_from_host
                        ? 'inquiry-message inquiry-message_host'
                        : 'inquiry-message',
                    senderLabel: message.is_from_host ? 'You' : guestName,
                    createdAtLabel: message.created_at
                        ? new Date(message.created_at).toLocaleString()
                        : ''
                }))
            };
        });
    }

    handleInquiryReplyChange(event) {
        const threadId = event.currentTarget?.dataset?.threadId;
        if (!threadId) return;

        this.inquiryReplyDrafts = {
            ...this.inquiryReplyDrafts,
            [threadId]: event.target.value
        };
        this.inquiryThreads = this.inquiryThreads.map(item => (
            item.thread_id === threadId
                ? {
                    ...item,
                    replyBody: event.target.value,
                    isReplyDisabled: !event.target.value.trim()
                }
                : item
        ));
    }

    async handleSendInquiryReply(event) {
        const threadId = event.currentTarget?.dataset?.threadId;
        const thread = this.inquiryThreads.find(item => item.thread_id === threadId);
        const replyBody = String(thread?.replyBody || '').trim();
        if (!threadId || !replyBody) return;

        this._isLoading = true;
        try {
            const idToken = await this.getIdToken();
            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }

            const op = post({
                apiName: 'api',
                path: '/cognito/host/messages/reply',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        threadId,
                        body: replyBody
                    }
                }
            });

            const { body } = await op.response;
            const payload = await body.json();
            const message = payload?.message;
            if (!message) {
                throw new Error('Message reply failed');
            }

            this.inquiryReplyDrafts = {
                ...this.inquiryReplyDrafts,
                [threadId]: ''
            };
            this.inquiryThreads = this.inquiryThreads.map(item => {
                if (item.thread_id !== threadId) return item;

                const createdAt = message.created_at || new Date().toISOString();
                const nextThread = {
                    ...item,
                    last_message_at: createdAt,
                    messages: [
                        ...(item.messages || []),
                        {
                            ...message,
                            is_from_host: true,
                            created_at: createdAt
                        }
                    ]
                };
                return this.formatInquiryThreads([nextThread])[0];
            });
            this.clearInquiryReplyTextarea(threadId);
        } catch (error) {
            this.showToast('Error sending reply', error?.message || error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    clearInquiryReplyTextarea(threadId) {
        const textarea = this.template.querySelector(`textarea[data-thread-id="${threadId}"]`);
        if (textarea) {
            textarea.value = '';
        }
    }

    toPreviousPage() {
        const onboardCmp = this.template.querySelector('x-get-wet-host-on-board');
        if (onboardCmp) {
            onboardCmp.toPreviousStep();
        }
    }
    toNextPage() {
        const onboardCmp = this.template.querySelector('x-get-wet-host-on-board');
        if (onboardCmp) {
            onboardCmp.toNextStep();
        }
    }
    async updateListing() {
        const onboardCmp = this.template.querySelector('x-get-wet-host-on-board');
        if (onboardCmp) {
            const editedListing = await onboardCmp.saveListing();
            const payloadKeys = Array.from(Object.keys(editedListing));
            if (editedListing) {
                const refreshedListings = this.listings.map(listing => {
                    if (listing.id === this.activeListingId) {
                        return Object.fromEntries(
                            Object.entries(listing).map(([key, value]) => {
                                return payloadKeys.includes(key)
                                    ? [key, editedListing[key]]
                                    : [key, value];
                            })
                        );
                    }
                    return listing;
                }); 
                this.listings = refreshedListings;
                this._templateListings = handleTemplateListings(refreshedListings);
            }
        }
    }

    // 
    async handleDeleteListing() {
        const inp = this.template.querySelector('x-slds-input[data-id="delete-input"]');
        if (inp) {
            const val = inp.getValue();
            if (!val || val !== this._activeListing.property_name) {
                inp.errorMe(`Your entry does not match "${this._activeListing.property_name}"`);
                return;
            } else {
                inp.removeErrorMe();
            }
        }
        this._isLoading = true;
        try {
            const idToken = await this.getIdToken();

            if (!idToken) {
                throw new Error('No idToken (not signed in)');
            }  

            const op = post({
                apiName: 'api',
                path: '/cognito/listing/request-delete',
                options: {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        listingId: this.activeListingId
                    }
                }
            });

            const { body } = await op.response;
            const resp = await body.json();
            console.log('here is resp in handleDeleteListing() of getWetHostHomePage.js: ', resp);
            this.showToast(
                'Listing successfully requested to be deleted', 
                'You will be emailed with further instructions once we review your listing.', 
                'info',
            );
            this.closeModal();

        } catch(error) {
            this.showToast('Error in handleDeleteListing() of getWetHostHomePage.js', error, 'error');
        } finally {
            this._isLoading = false;
        }
    }

    toastObj;
    showToast(title, message, variant, mode=null) {
        const modeP = mode 
            ? mode 
                : variant === 'success'
            ? 'dismissible'
            : 'sticky';
        
        this.toastObj = { 
            variant: variant, 
            mode: modeP, 
            message: message,
            header: { 
                text: title
            }        
        };
    }

}
